import React from "react";
import * as Icon from "react-bootstrap-icons";
import * as Utils from "../../inc/Utils";
import {Link, NavLink} from "react-router-dom";
import Role from "../../inc/Role";
import toast, { Toaster } from 'react-hot-toast';

import Pagination from "react-js-pagination";
import {Config} from '../../Config'
import {CopyToClipboard} from "react-copy-to-clipboard";
import DatePicker from "react-datepicker";
import {ADSNAMING_GROUP_ALWAYS_ON} from "../../inc/Utils";
import {ADSNAMING_GROUP_ADHOC_CAMPAIGN} from "../../inc/Utils";
import * as XLSX from "xlsx";
import Select from 'react-select'
import {ADSNAMING_GROUP_SPECIAL} from "../../inc/Utils";

export default function AdsNamingSetName() {
    const roles = new Role();
    //region search
    let btnTextDefault = 'ค้นหา';
    let btnTextLoading = 'กำลังค้นหา..';
    let [showSearch, setShowSearch] = React.useState(false);
    let [itemPerpage, setItemPerpage] = React.useState(10);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0);
    let [startDate, setStartDate] = React.useState(null);
    let [endDate, setEndDate] = React.useState(null);
    let [typeId, setTypeId] = React.useState(null);
    let [type, setType] = React.useState(null);
    let [sortField, setSortField] = React.useState(null);
    let [sortType, setSortType] = React.useState(null);
    let [checkedIds, setCheckedIds] = React.useState([]);
    let [name, setName] = React.useState(null);
    const onSearch = (e) => {
        e.preventDefault();
        getData({
            name : e.target.elements.name.value,
            typeId : typeId != null ? typeId.id : null,
            startDate : startDate ?? null,
            endDate : endDate ?? null,
            sortField : e.target.elements.sortField.value,
            sortType : e.target.elements.sortType.value
        });
        setTypeId(typeId);
        setSortField(e.target.elements.sortField.value);
        setSortType(e.target.elements.sortType.value);
    };
    const onSearchReset = () => {
        setName('');
        setTypeId(null);
        setSortField('id');
        setSortType('DESC');
        setActivePage(0);
        setStartDate(null);
        setEndDate(null);
        getData({
            name : null,
            typeId : null,
            startDate : null,
            endDate : null,
            sortField: 'id',
            sortType: 'DESC',
            activePage: 1
        });
    };
    const onChangeName = (value) => setName(value);
    const onChangeTypeId = (obj) => setTypeId(obj);
    const onChangeSortField = (Id) => setSortField(Id);
    const onChangeSortType = (Id) => setSortType(Id);
    const onPageChange = (pageNum) => {
        setActivePage(pageNum);
        getData({
            name : name ?? null,
            typeId : typeId != null ? typeId.id : null,
            startDate : startDate ?? null,
            endDate : endDate ?? null,
            sortField: sortField ?? null,
            sortType: sortType ?? null,
            activePage: pageNum,
        });
    };
    //endregion

    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');

    React.useEffect(() => {
        getData({
            name : null,
            typeId : null,
            startDate : null,
            endDate : null,
            sortField: 'id',
            sortType: 'DESC'
        });
        (async function() {
            try {
                const resType = await Utils.getAdsType();
                setType(resType);
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const getData = (params) => {
        setLoading(true);
        if(params.itemPerpage) {
            itemPerpage = params.itemPerpage;
        }
        fetch(Config.url.API_URL +'/api/adsNamingSetName/listing', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                name: params.name ?? null,
                typeId: params.typeId ?? null,
                startDate : params.startDate ?? null,
                endDate : params.endDate ?? null,
                sortField: params.sortField ?? 'id',
                sortType: params.sortType ?? 'DESC',
                itemPerpage: itemPerpage,
                startItem: params.activePage > 1 ? (params.activePage*itemPerpage)-itemPerpage : 0,
            })
        }).then(response => {
            setLoading(false);
            if(response.ok) {
                return response.json();
            }
            else {
                return response.json().then(err => Promise.reject(err));
            }
        }).then(result => {
            setCountAllItem(result.count);
            setTotalPage(result.count > 0 ? (result.count / itemPerpage) : 1);
            setData(result.rows);
        }).catch(err => {
            toast.error(err.message);
        });
    };

    const onChangeItemPerpage = (e) => {
        setItemPerpage(e.target.value);
        setActivePage(1);
        getData({
            name : null,
            nameEn : null,
            geoId: null,
            sortField: 'id',
            sortType: 'DESC',
            activePage: 1,
            itemPerpage: e.target.value
        });
    };

    const onCopyFullUrl = () => {
        toast.success("คัดลอก Full URL แล้ว", {autoClose: 1000});
    };

    const onChangeStartDate = (value) => {
        setStartDate(value);
        if(value > endDate) {
            setEndDate('');
        }
    };
    const onChangeEndDate = (value) => {
        setEndDate(value);
    };

    const onCheckAll = (isChecked) => {
        if(data.length) {
            data.map((row, index) => {
                let chkSourceId = 'checkId' + row.id;
                if(document.getElementById(chkSourceId)) {
                    document.getElementById(chkSourceId).checked = isChecked;
                }
            });
            onCheckedItem();
        }
    };

    const onCheckedItem = () => {
        let ids = [];
        if(data.length) {
            data.map(row => {
                let chkSourceId = 'checkId' + row.id;
                if(document.getElementById(chkSourceId) && document.getElementById(chkSourceId).checked) {
                    ids.push(row.id);
                }
            });
            setCheckedIds(ids);
        }
    };

    const onExportSelected = () => {
        if(checkedIds.length > 0) {
            let jsonData = [];
            if(data.length) {
                data.map(row => {
                    if(checkedIds.includes(row.id)) {
                        jsonData.push({
                            ID: row.id,
                            Type: Utils.adsNamingCampaignTypeName(row.typeId),
                            CampaignName: row.params,
                            CreatedBy: row.user.contact,
                            CreatedDate: Utils.dateYMDHI(row.createdAt)
                        });
                    }
                });
            }
            const worksheet = XLSX.utils.json_to_sheet(jsonData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            XLSX.writeFile(workbook, "adsNamingSetName_Export_" + Utils.getDate() + ".xlsx");
        }
    };

    return (
        <main><Toaster position="bottom-right" />
            <div className="row table-toolbar mb-2">
                <div className="col-md-4 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate Ads Set Naming</div>
                    <span className="ms-1">/</span> <span className="text-muted">Listing</span>
                </div>
                <div className="col-md-8 text-end align-self-center toolbars">
                    {roles.isCreate(Utils.MENU_ADSNAMING_GENERATE) ? (
                        <NavLink className="btn btn-sm btn-primary" to='/adsNamingSetName/createAlways'><span><Icon.PlusLg/> Create Project</span></NavLink>
                    ) : ''}
                    {roles.isCreate(Utils.MENU_ADSNAMING_GENERATE) ? (
                        <NavLink className="btn btn-sm btn-primary ms-2" to='/adsNamingSetName/createAdHoc'><span><Icon.PlusLg/> Create Promotion</span></NavLink>
                    ) : ''}
                    {roles.isCreate(Utils.MENU_ADSNAMING_GENERATE) ? (
                        <NavLink className="btn btn-sm btn-primary ms-2" to='/adsNamingSetName/createSpecial'><span><Icon.PlusLg/> Create Special</span></NavLink>
                    ) : ''}
                    {roles.isCreate(Utils.MENU_ADSNAMING_GENERATE) ? (
                        <NavLink className="btn btn-sm btn-success ms-2" to='/adsNamingSetName/import'><span><Icon.FileExcel/> นำเข้า</span></NavLink>
                    ) : ''}
                </div>
            </div>
            {isLoading ? (<span className="spinner-grow spinner-grow-sm"></span>) :
            <>
                <div className="bg-light border rounded my-2">
                    <button type="button" className="btn btn-light w-100 text-start" onClick={() => {setShowSearch(!showSearch)}}><Icon.Search/> ค้นหา | เรียงลำดับ</button>
                    <div className={showSearch ? 'd-block p-3':'d-none'}>
                        <form className="row g-3" onSubmit={onSearch} onReset={onSearchReset}>
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">Campaign Name</label>
                                <input type="text" className="form-control" id="name" value={name ?? ''} onChange={(event) => onChangeName(event.target.value)}  maxLength={100} />
                            </div>
                            <div className="col-12 col-sm-6">
                                <label htmlFor="typeId" className="form-label">Type</label>
                                <Select
                                    isClearable={true}
                                    classNamePrefix="form-select-search"
                                    options={type}
                                    onChange={(event) => onChangeTypeId(event)}
                                    defaultValue={typeId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12 col-sm-6">
                                <label htmlFor="sortField" className="form-label">เรียงลำดับ</label>
                                <div className="row">
                                    <div className="col-8">
                                        <select className="form-select" id="sortField" onChange={(event) => onChangeSortField(event.target.value)} value={sortField ?? ''}>
                                            <option value="id">Id</option>
                                            <option value="params">Campaign Name</option>
                                        </select>
                                    </div>
                                    <div className="col-4">
                                        <select className="form-select" id="sortType" onChange={(event) => onChangeSortType(event.target.value)} value={sortType ?? ''}>
                                            <option value="DESC">DESC</option>
                                            <option value="ASC">ASC</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6">
                                <label htmlFor="name" className="form-label">Start Date</label>
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => onChangeStartDate(date)}
                                    startDate={startDate}
                                    endDate={endDate}
                                    dateFormat="yyyy-MM-dd"
                                    wrapperClassName="w-100"
                                    className="form-control w-100" />
                            </div>
                            <div className="col-12 col-sm-6">
                                <label htmlFor="name" className="form-label">End Date</label>
                                <DatePicker
                                    selected={endDate}
                                    onChange={(date) => onChangeEndDate(date)}
                                    startDate={startDate}
                                    endDate={endDate}
                                    minDate={startDate}
                                    dateFormat="yyyy-MM-dd"
                                    wrapperClassName="w-100"
                                    className="form-control" />
                            </div>
                            <div className="col-12">
                                <button type="submit" className="btn btn-primary">{isLoading ? btnTextLoading : btnTextDefault}</button>
                                <button type="reset" className="btn btn-light border ms-2">รีเซ็ต</button>
                            </div>
                        </form>
                    </div>
                </div>
                {data.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                    <>
                        <button type="button" className={"btn btn-success py-1 my-2" + (checkedIds.length > 0 ? '':' d-none')} onClick={() => onExportSelected()}>Export Selected</button>
                        <div className="table-container shadow">
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th className="w50 text-center">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="checkAll" onChange={e => {onCheckAll(e.target.checked)}} />
                                        <label className="form-check-label" htmlFor="checkAll"></label>
                                    </div>
                                </th>
                                <th className="w50">ID</th>
                                <th className="w150">Type</th>
                                <th>Campaign Name</th>
                                <th className="w70 text-center">Copy</th>
                                <th className="w70 text-center">Duplicate</th>
                                <th className="w100 text-center">CreatedBy</th>
                                <th className="w100 text-center">Created Date</th>
                                {roles.isDelete(Utils.MENU_ADSNAMING_GENERATE) ? (
                                    <th className="w70 text-center">ลบ</th>
                                ) : ''}
                            </tr>
                            </thead>
                            <tbody>
                            {data.map((row, index) => {
                                let editPath = '';
                                if(row.typeId === ADSNAMING_GROUP_ALWAYS_ON) {
                                    editPath = 'createAlways';
                                }
                                else if(row.typeId === ADSNAMING_GROUP_ADHOC_CAMPAIGN) {
                                    editPath = 'createAdHoc';
                                }
                                else if(row.typeId === ADSNAMING_GROUP_SPECIAL) {
                                    editPath = 'createSpecial';
                                }
                                return (
                                    <tr key={index} id={"rowId" + row.id}>
                                        <th className="text-center">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" id={"checkId"+row.id} value={row.id} onClick={() => onCheckedItem()} />
                                                <label className="form-check-label" htmlFor={"checkId"+row.id} ></label>
                                            </div>
                                        </th>
                                        <td>{row.id}</td>
                                        <td>{Utils.adsNamingCampaignTypeName(row.typeId)}</td>
                                        <td><div className="noselect-url">{row.params}</div></td>
                                        <td className="text-center">
                                            <CopyToClipboard text={row.params} onCopy={() => {onCopyFullUrl()}}>
                                                <button type="button" className={"btn btn-sm btn-light" + (row.params ? '':' d-none')}><Icon.Files /></button>
                                            </CopyToClipboard>
                                        </td>
                                        <td className="text-center">
                                            {roles.isCreate(Utils.MENU_ADSNAMING_GENERATE) ? (
                                                <Link className="btn btn-sm btn-light mx-1" to={'/adsNamingSetName/'+editPath+'/' + Utils.encodeItem({id: row.id,  createdAt: row.createdAt})}><Icon.Send/></Link>
                                            ) : ''}
                                        </td>
                                        <td className="text-center small">{row.user.contact}</td>
                                        <td className="text-center">{Utils.dateTime(row.createdAt)}</td>
                                        {roles.isDelete(Utils.MENU_ADSNAMING_GENERATE) ? (
                                            <td className="text-center"><button className="btn btn-sm btn-light mx-1" onClick={() => Utils.deleteItem('adsNamingSetName', row.id, row.params)}><Icon.Trash/></button></td>
                                        ) : ''}
                                    </tr>
                                );
                            })
                            }
                            </tbody>
                        </table>
                        </div>
                        <div className="row mt-3">
                            <div className="col-12 col-sm-4 mt-2 mt-sm-0 text-end align-self-center">
                                <select className="form-select w100" id="itemPerpage" onChange={(e) => onChangeItemPerpage(e)} value={itemPerpage}>
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                            <div className="col-12 col-sm-8">
                                <div className={totalPage > 1 ? 'my-3':'d-none'}>
                                    <Pagination
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        innerClass="pagination justify-content-sm-end"
                                        activePage={activePage}
                                        itemsCountPerPage={itemPerpage}
                                        totalItemsCount={countAllItem}
                                        pageRangeDisplayed={5}
                                        onChange={(pageNum) => onPageChange(pageNum)}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                }
            </>
            }
        </main>
    );
} 